export default "__VITE_ASSET__DG0fIn1x__"